import { ConfirmationModalFooter } from '@/components/ConfirmationModal/Base/Footer';
import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { ButtonV2Props, Modal } from '@moneyforward/ap-frontend-components';
import { CSSProperties, FC, memo, useMemo } from 'react';
import { Contents } from './Contents';

type SendConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
};

export const SendConfirmationModal: FC<SendConfirmationModalProps> = memo(
  ({ open, onClose, onConfirm, isPending }) => {
    const containerRef = useGlobalContainerRef();
    const { t } = useTranslation();

    const cancelButtonProps: ButtonV2Props = useMemo(
      () => ({
        isSecondary: true,
        isTertiary: true,
        onClick: onClose,
        size: 'sm',
        children: t('cancel'),
        isDisabled: isPending,
      }),
      [onClose, t, isPending]
    );

    const okButtonProps: ButtonV2Props = useMemo(
      () => ({
        onClick: onConfirm,
        size: 'sm',
        children: t('received_invoice_reconciliation_button_send'),
        isLoading: isPending,
        isDisabled: isPending,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        style: {
          ...(isPending && {
            '--background-color': 'var(--color-background-disabled)',
          }),
        } as CSSProperties,
      }),
      [onConfirm, t, isPending]
    );

    return (
      <Modal
        open={open}
        onClose={onClose}
        size='md'
        title={t('received_invoice_reconciliation_send_confirm_title')}
        getContainer={containerRef}
        mask
        footer={
          <ConfirmationModalFooter
            cancelButton={cancelButtonProps}
            okButton={okButtonProps}
          />
        }
      >
        <Contents />
      </Modal>
    );
  }
);

SendConfirmationModal.displayName = 'SendConfirmationModal';
